import React, { ReactText } from 'react';
import { trackEvent } from 'utils/Tracking';
import Link from 'next/link';

import styled from 'styled-components';
import { addPrefix } from 'utils/addPrefix';
import ReactGA from 'react-ga';

const StyledLink = styled('a')<{ variant: string; width?: ReactText }>`
  width: ${({ width }) =>
    width
      ? typeof width === 'string'
        ? `width: ${width};`
        : `width: ${width}px;`
      : '100%;'}
  text-decoration: none;

  cursor: pointer;

  ${({ variant }) => {
    switch (variant) {
      case 'classic':
        return `
  color: #2b6be9;
  font-weight: bold;
  `;
      case 'black':
        return `
  color: #000;
  font-weight: bold;
  `;

      case 'meetbutter':
        return `
        
    
    color: #2F80ED
    `;

      default:
        return `
        color: inherit;
      `;
    }
  }}
`;

export interface ILinkTrackerProps {
  href?: string; //
  external?: boolean; // is an external link // TODO we can remove this and have a regex util to determine if it's external or internal link
  children: any;
  onClick?: (e?: any) => void;
  className?: string;
  style?: any;
  variant?: string; // classic, black, bold
  disabled?: boolean;
  newTab?: boolean; // open in new tab (for )
  eventId?: string; // event id
  eventProperties?: ReactGA.EventArgs; // this is the event property e.g. { "userId": "1234" }
  userTraits?: any; // this is for super properties or user properties e.g. { "last-meeting": "123012323932" }
  eventDisabled?: boolean; //event disabled
  button?: boolean; // pass this to prevent adding a tag
  width?: ReactText;
}

export const LinkTracker = ({
  href, //
  external, // is an external link // TODO we can remove this and have a regex util to determine if it's external or internal link
  children,
  onClick,
  className,
  button,
  style,
  variant, // classic, black, bold
  disabled,
  newTab = false, // open in new tab (for )
  eventProperties, // this is the event property e.g. { "userId": "1234" }
  eventDisabled, //event disabled if
  width,
}: ILinkTrackerProps) => {
  const handleClick = e => {
    eventProperties &&
      !eventDisabled &&
      trackEvent({
        args: { ...eventProperties },
      });

    onClick && onClick(e);
  };

  if (disabled) {
    return children;
  }

  if (!href) {
    return React.cloneElement(children, {
      onClick: handleClick,
      style: { cursor: 'pointer' },
    });
  }

  const externalURL = addPrefix('https://', href);

  if (external) {
    if (button) {
      return React.cloneElement(children, {
        onClick: handleClick,
        style: style,
        href: externalURL,
        target: '_blank',
        rel: 'noopener noreferrer',
      });
    }
    return (
      <StyledLink
        variant={variant}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        href={externalURL}
        className={className}
        style={style}
        width={width}
      >
        {children}
      </StyledLink>
    );
  }

  if (button) {
    return React.cloneElement(children, {
      onClick: handleClick,
      href,
      style: style,
      target: newTab ? '_blank' : '',
    });
  }
  return (
    <Link href={href}>
      <StyledLink
        variant={variant}
        onClick={handleClick}
        className={className}
        style={style}
        target={newTab ? '_blank' : ''}
        href={href}
        width={width}
      >
        {children}
      </StyledLink>
    </Link>
  );
};
